import * as Actions from './actionTypes';
import defaultHeaderOptions from '../shared/defaultHeaderOptions';
import * as APIUtils from '../shared/apiUtils';

// complex thunk actions
export function fetchLiveStreams(eventId, page, perPage) {
  return (dispatch) => {
    dispatch(fetchLiveStreamsBegin());
    let url = `${APIUtils.getBaseApiUrl()}/events/${eventId}/live_streams?starts_at_ascending=true&include_livestreamable=true`
    if(!APIUtils.isAccountLoggedIn()) {
      url = `/api/public/events/${eventId}/live_streams?starts_at_ascending=true&include_livestreamable=true`;
    }
    url+= `&per_page=${perPage}&page=${page}`;
    return fetch(url, {headers: defaultHeaderOptions})
      .then(APIUtils.checkStatus)
      .then(APIUtils.parseJSON)
      .then(data => {
        dispatch(fetchLiveStreamsSuccess(data));
        return data;
      })
      .catch(error => dispatch(fetchLiveStreamsError(error)));
  };
}

export function fetchSurveys(eventId, page, perPage) {
  return (dispatch) => {
    dispatch(fetchSurveysBegin());
    let url = `${APIUtils.getBaseApiUrl()}/events/${eventId}/all_surveys?not_taken=true&per_page=${perPage}&page=${page}`
    if(!APIUtils.isAccountLoggedIn()) {
      url = `/api/public/events/${eventId}/all_surveys?per_page=${perPage}&page=${page}`;
    }
    return fetch(url, {headers: defaultHeaderOptions})
      .then(APIUtils.checkStatus)
      .then(APIUtils.parseJSON)
      .then(data => {
        dispatch(fetchSurveysSuccess(data));
        return data;
      })
      .catch(error => dispatch(fetchSurveysError(error)));
  };
}

export function fetchSurveyCanBeTaken(eventId) {
  return (dispatch) => {
    dispatch(fetchSurveyCanBeTakenBegin());
    let url = `/api/public/events/${eventId}/all_surveys/can_be_taken`;
    return fetch(url, {headers: defaultHeaderOptions})
      .then(APIUtils.checkStatus)
      .then(APIUtils.parseJSON)
      .then(data => {
        dispatch(fetchSurveyCanBeTakenSuccess(data));
        return data;
      })
      .catch(error => dispatch(fetchSurveyCanBeTakenError(error)));
  };
}

// normal actions
export function fetchLiveStreamsBegin() {
  return {
    type: Actions.FETCH_LIVE_STREAMS_BEGIN
  };
}

export function fetchLiveStreamsSuccess(data) {
  return {
    type: Actions.FETCH_LIVE_STREAMS_SUCCESS,
    payload: data
  };
}

export function fetchLiveStreamsError(error) {
  return {
    type: Actions.FETCH_LIVE_STREAMS_ERROR,
    error: error
  };
}

export function fetchSurveysBegin() {
  return {
    type: Actions.FETCH_SURVEYS_BEGIN
  };
}

export function fetchSurveysSuccess(data) {
  return {
    type: Actions.FETCH_SURVEYS_SUCCESS,
    payload: data
  };
}

export function fetchSurveysError(error) {
  return {
    type: Actions.FETCH_SURVEYS_ERROR,
    error: error
  };
}

export function fetchSurveyCanBeTakenBegin() {
  return {
    type: Actions.FETCH_SURVEYS_CAN_BE_TAKEN_BEGIN
  };
}

export function fetchSurveyCanBeTakenSuccess(data) {
  return {
    type: Actions.FETCH_SURVEYS_CAN_BE_TAKEN_SUCCESS,
    payload: data
  };
}

export function fetchSurveyCanBeTakenError(error) {
  return {
    type: Actions.FETCH_SURVEYS_CAN_BE_TAKEN_ERROR,
    error: error
  };
}


export function goBackToSurveys() {
  return {
    type: Actions.GO_BACK_TO_SURVEYS
  }
}

export function closeSurveyModal() {
  return  {
    type: Actions.CLOSE_SURVEY_MODAL
  }
}

export function triggerShowSurveyModal() {
  return  {
    type: Actions.SHOW_SURVEY_MODAL
  }
}

export function showSurveyFromId(surveyId, buttonType) {
  return {
    type: Actions.SHOW_SURVEY_FROM_ID,
    surveyId: surveyId,
    buttonType: buttonType
  }
}

// export function surveyModalButtonClicked() {
//   return {
//     type: Actions.SURVEY_MODAL_BUTTON_CLICKED
//   }
// }
